import React from "react";
import ReviewRatingStars from "./ReviewRatingStars";

function ReviewHeader({ review, isOwner, onEdit, onDelete }) {
  // 1. 이미지 경로 처리
  const getAvatarUrl = (avatarPath) => {
    const DEFAULT_AVATAR = "/images/avatar/avatar_basic.png";
    if (!avatarPath) return DEFAULT_AVATAR;
    if (avatarPath.startsWith("http") || avatarPath.startsWith("/")) {
      return avatarPath;
    }
    return `/images/avatar/${avatarPath}`;
  };

  // 2. 날짜 포맷팅
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dateString.substring(0, 10).replace(/-/g, ".");
  };

  return (
    // items-start를 items-center로 변경하여 수직 중앙 정렬
    <div className="flex justify-between items-center mb-3">
      {/* 왼쪽 영역: 아바타 + (닉네임 & 별점) */}
      <div className="flex items-center gap-3">
        <img
          src={getAvatarUrl(review.avatarImg)}
          alt="유저 아바타"
          className="w-10 h-10 rounded-full border border-gray-100 object-cover shadow-sm"
          onError={(e) => {
            e.target.src = "/images/avatar/avatar_basic.png";
          }}
        />

        {/* 닉네임과 별점을 한 줄로 정렬 */}
        <div className="flex items-center gap-2">
          <span className="text-[14px] text-gray-800 font-bold leading-none">
            {review.nickname || review.userId}
          </span>
          <div className="flex items-center">
            <ReviewRatingStars value={review.reviewRating} readOnly={true} />
          </div>
        </div>
      </div>

      {/* 오른쪽 영역: 날짜 + 수정/삭제 버튼 */}
      {/* mt-1을 제거하고 items-center로 정렬 유지 */}
      <div className="flex items-center gap-3">
        <span className="text-xs text-gray-400 leading-none">
          {formatDate(review.createdAt || review.reviewDate)}
        </span>

        {isOwner && (
          <div className="flex gap-2 border-l pl-3 border-gray-200">
            <button
              onClick={onEdit}
              className="text-xs text-gray-400 underline hover:text-gray-600 leading-none"
            >
              수정
            </button>
            <button
              onClick={onDelete}
              className="text-xs text-gray-400 underline hover:text-gray-600 leading-none"
            >
              삭제
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReviewHeader;
